export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed;
export const selectInsufficientCreditsModalOpen = (state) => state.ui.insufficientCreditsModalOpen;